'use client';
import { Center, Group, Select, SelectProps, Text } from '@mantine/core';
import React, { FC } from 'react';
import {
	CZFlag,
	DEFlag,
	ESFlag,
	FRFlag,
	GBFlag,
	PLFlag,
} from 'mantine-flagpack';
import { SlCheck } from 'react-icons/sl';
import styles from './CountryPicker.module.scss';

export const CountryPicker: FC<SelectProps> = (props: SelectProps) => {
	const icons: Record<string, React.ReactNode> = {
		pl: <PLFlag w="lg" className={styles['flag']} />,
		de: <DEFlag w="lg" className={styles['flag']} />,
		cs: <CZFlag w="lg" className={styles['flag']} />,
		fr: <FRFlag w="lg" className={styles['flag']} />,
		es: <ESFlag w="lg" className={styles['flag']} />,
		gb: <GBFlag w="lg" className={styles['flag']} />,
	};
	const renderSelectOption: SelectProps['renderOption'] = ({
		option,
		checked,
	}) => (
		<Group flex="1" gap="sm" className={styles['picker-item']} align="center">
			{icons[option.value]}
			<Text size="lg">{option.label}</Text>
			{checked && (
				<Center ml="auto">
					<SlCheck />
				</Center>
			)}
		</Group>
	);
	return (
		<Select
			data={[
				{
					value: 'pl',
					label: 'Polska',
				},
				{
					value: 'de',
					label: 'Niemcy',
				},
				{
					value: 'cs',
					label: 'Czechy',
				},
				{
					value: 'fr',
					label: 'Francja',
				},
				{
					value: 'es',
					label: 'Hiszpania',
				},
				{
					value: 'gb',
					label: 'Wielka Brytania',
				},
			]}
			renderOption={renderSelectOption}
			{...props}
		/>
	);
};
